export interface ICourseDetails {
  _id: string;
  title: string;
  author: string;
  authorImage: string;
  authorDescription: string;
  originalPrice: number;
  discountedPrice: number;
  numOfRatings: number;
  rating: number;
  level: string;
  isBestSeller: boolean;
  thumbnail: string;
  description: string;
  requirements: string;
  learningOutcomes: string[];
  longdescription: string;
}

export interface IUserDetails {
  _id: string;
  name: string;
  email: string;
  password: string;

  cartItems: ICourseDetails[];

  enrolledCourses: string[];
}

export const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export const FRONT_END_BASE_URL = process.env.REACT_APP_FRONT_END_BASE_URL;

